module.exports = __webpack_public_path__ + "img/4.0f2485fa.png";